import React from 'react';
import { JobsitePulseAccessEvent } from 'containers/jobsite/tabs/jobsitePulse/types';
import { Avatar } from '@odin-labs/components';
import { ArrowLeftFromLineIcon, ArrowRightToLineIcon } from 'components/icons';
import { cn, getInitialsForUser, getUserFullName } from 'utils';
import { useJobsitePulse } from './JobsitePulseProvider';
import { snapshotPanelStyles } from './styles';

export function SnapshotAccessEvent(
  props: JobsitePulseAccessEvent,
): React.ReactElement {
  const { localizedTime, direction, worker, gateway } = props;
  const { user, profilePictureCropped } = worker ?? {};
  const userFullName = getUserFullName(user);
  const localizedTimeWithoutMilliseconds = localizedTime?.split('.')[0];

  const directionIcon = React.useMemo(() => {
    if (direction === 'inbound') {
      return <ArrowRightToLineIcon className="odin-text-purple-700" />;
    }
    if (direction === 'outbound') {
      return <ArrowLeftFromLineIcon className="odin-text-purple-700" />;
    }
    return null;
  }, [direction]);

  return (
    <div
      className={cn(
        'odin-border-b',
        'odin-border-odin-slate-200',
        'odin-flex',
        'odin-items-center',
        'odin-gap-2',
        'odin-py-2',
      )}
    >
      <div className="odin-flex odin-gap-2 odin-items-center">
        {directionIcon}
        <p className="odin-text-slate-500 odin-text-sm">
          {localizedTimeWithoutMilliseconds}
        </p>
      </div>
      <div className="odin-flex odin-gap-2 odin-flex-1 odin-items-center">
        <Avatar
          size="xs"
          src={profilePictureCropped?.downloadUrl}
          placeholder={getInitialsForUser(user)}
        />
        <p
          className="odin-text-xs odin-line-clamp-2 odin-flex-1"
          title={userFullName}
        >
          {userFullName}
        </p>
      </div>
      <p
        className="odin-text-xs odin-line-clamp-2 odin-text-right odin-flex-1 odin-text-slate-500"
        title={gateway}
      >
        {gateway}
      </p>
    </div>
  );
}

export function SnapshotAccessEventList(): React.ReactElement {
  // TODO: implement loading skeleton
  const { accessEvents, loading: stateLoading } = useJobsitePulse();
  const loading = stateLoading?.jobsitePulse;

  if (loading) {
    return <p className="odin-text-slate-500">Loading access events...</p>;
  }

  if (!accessEvents?.length) {
    return <p className="odin-text-slate-500">No access events available</p>;
  }

  return (
    <div className="odin-flex odin-flex-col">
      {accessEvents.map((event) => (
        <SnapshotAccessEvent key={event.id} {...event} />
      ))}
    </div>
  );
}

export function SnapshotAccessEvents(): React.ReactElement {
  return (
    <div className={snapshotPanelStyles.accessEvents}>
      <h3 className="odin-font-bold">Access events</h3>
      <SnapshotAccessEventList />
    </div>
  );
}
